import { ExcelPurchaseItemPayload, ManualPurchaseItemPayload } from '../../../services/purchases.service'

import { ManualEntryFormValues } from './manual-entry-form'

type PurchaseFormProduct = ManualEntryFormValues['products'][number]

function optionalPurchaseFields(product: PurchaseFormProduct): Partial<ManualPurchaseItemPayload> {
  return {
    ...(product.quantity !== undefined ? { quantity: product.quantity } : {}),
    ...(product.cost !== undefined ? { cost_without_taxes: product.cost } : {}),
    ...(product.taxId ? { tax_id: Number(product.taxId) } : {}),
    ...(product.margin !== undefined ? { profit_percentage: product.margin } : {}),
    ...(product.requiresLot && product.lotNumber ? { lot_number: product.lotNumber } : {}),
    ...(product.requiresLot && product.expiryDate ? { expiration_date: product.expiryDate } : {}),
  }
}

function newProductFields(product: PurchaseFormProduct): ManualPurchaseItemPayload {
  return {
    name: product.name.trim(),
    description: product.description.trim(),
    barcode: product.barcode.trim(),
    ...(product.satKeyCode ? { sat_product_key_code: product.satKeyCode } : {}),
    ...(product.satKeyName ? { sat_product_key_name: product.satKeyName } : {}),
    category_id: Number(product.categoryId),
    department_id: Number(product.departmentId),
    product_type_id: Number(product.productTypeId),
    unit_id: Number(product.unitId),
    ...optionalPurchaseFields(product),
  }
}

export function buildManualPurchaseItemPayload(product: PurchaseFormProduct): ManualPurchaseItemPayload {
  return newProductFields(product)
}

export function buildExcelPurchaseItemPayload(product: PurchaseFormProduct): ExcelPurchaseItemPayload {
  const base: ExcelPurchaseItemPayload = {
    origin: product.origin,
    row_key: product.rowKey,
    ...(product.rowNumber !== undefined ? { row_number: product.rowNumber } : {}),
    barcode: product.barcode.trim(),
    ...optionalPurchaseFields(product),
  }

  if (product.matchStatus === 'existing_product') {
    return base
  }

  return {
    ...base,
    ...newProductFields(product),
  }
}
